
import { cartGet, cartAdd, cartGetCurrent, cartUpdate, cartChange } from '@process-creative/slate-theme-tools';

import { bindAssignedElements } from './utils';

import { CustomiserOption } from './customiser-option';
import { CustomiserMeasurementOption } from './customiser-measurement-option';
import { Option } from './types';

export const CLASS_OPEN = 'is-bundle-builder-open';

// const template = document.createElement('template');

const template = document.createElement('template');

  template.innerHTML = `
    <style>
      :host {
        display: block;
        width: 100%;
      }

      :root {
        display: flex;
        overflow: visible;
      }

      .option-picker {
        margin-left: -1.25rem;
        margin-right: -1.25rem;
        overflow-x: auto;
        scrollbar-width: none;
        padding: 0 1.25rem;
      }

      ::slotted(fieldset) {
        display: inline-flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: stretch;
        border: none;
        gap: .75rem;
        padding: 0;
        margin: 0;
        overflow: visible;
      }

      @media only screen and (min-width: 395px) {
        ::slotted(fieldset) {
          margin-left: auto;
          margin-right: auto;
          overflow: visible;
        }
      }

      @media only screen and (min-width: 1100px) {
        :host {
          margin-left: 0;
          margin-right: 0;
          width: 100%;
          overflow: visible;
        }

        ::slotted(fieldset) {
          gap: 16px;
          flex-wrap: wrap;
          margin-left: 0;
          margin-right: 0;
          padding: 0;
          width: 100%;
          overflow: visible;
          justify-content: flex-start;
        }

        .option-picker {
          overflow: visible;
        }
      }
    </style>

    <div class="option-picker" part="root">
      <slot></slot>
    </div>
`


export class CustomiserOptionPicker extends HTMLElement {

  // private optionsData: Option[];
  private options:CustomiserOption[]|[] = [];
  private measurementOptions:CustomiserMeasurementOption[]|[];
  private step_id:string = this.getAttribute('step-id');
  private model_id_field:string = this.getAttribute('model-id-field');
  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    
    shadowRoot.appendChild(template.content.cloneNode(true));
    
    this.options = [...this.querySelectorAll('customiser-option')];
    if (!this.options.length) {
      console.warn('You may need to render some options in here!', this);
    }

    this.measurementOptions = [...this.querySelectorAll('customiser-measurement-option')];

  }

  get selectableOptions() {
    return this.options.filter(option => option.current_state === 'Visible')
  }

  selectNextAvailableOption(triggerIteration) {
    this.selectableOptions[0]?.handleChange(triggerIteration);
  }

  triggerError(isError:boolean) {
    // Uncomment this if we need to apply error handling on the whole option picker
    // this.classList.toggle('is-error', isError); 
    this.allOptions.forEach(opt => opt.triggerError(isError));
  }

  get allOptions() {
    return [ ...this.options, ...this.measurementOptions ];
  }

  get dependencies() {
    return this.allOptions.filter(option => {
      return option.dependencies?.measurementDependency ||
      option.dependencies?.idGroups?.length
    })
    .map(option => {
      return {
        option_id: option.option_id,
        dependencies: option.dependencies
      }
    });
  }

  setOption(option_id:string|undefined) {
    this.options.forEach(option => option.setSelected(option.option_id === option_id))
  }

  public setStepId(id:string) {
    // This function is implemented in multiple spots.
    // If changing it here, update the otehr locations
    this.step_id = id;
    const componenentsWithStepId = this.querySelectorAll('[step-id]');

    componenentsWithStepId.forEach(component => component?.setStepId(id))
  }

  public getOptionById(optionId:string) {
    return this.options.find(option => option.option_id === optionId)
  }

  get selectedOptions() {
    return this.options.find(opt => opt.isSelected)
  }

  reset() {
    // triggers a click on the first option of each step
    this.options?.[0]?.handleChange(); 
  }


}

if(!customElements.get('customiser-option-picker')) {
  customElements.define('customiser-option-picker', CustomiserOptionPicker);
}